var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOctagon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2209,
    height: 1218,
    viewBox: "0 0 2209 1218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0144928,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1911.57 235.426L2200.61 385.356C2208.92 389.666 2213.37 398.953 2211.53 408.129L2147.47 727.373C2146.38 732.8 2143.19 737.577 2138.6 740.666L1751.86 1000.82C1748.25 1003.25 1743.97 1004.49 1739.62 1004.39L1331.53 994.293C1323.64 994.098 1316.52 989.495 1313.11 982.379L1190.34 726.346C1186.93 719.23 1187.79 710.801 1192.58 704.527L1440.22 380.003C1442.86 376.542 1446.51 373.988 1450.67 372.693L1895.66 234.018C1900.94 232.371 1906.66 232.877 1911.57 235.426ZM2202.45 381.806C2212.34 386.936 2217.64 397.992 2215.45 408.916L2151.39 728.16C2150.1 734.62 2146.3 740.307 2140.83 743.985L1754.09 1004.14C1749.79 1007.03 1744.7 1008.51 1739.52 1008.39L1331.43 998.292C1322.04 998.059 1313.57 992.58 1309.5 984.109L1186.73 728.075C1182.67 719.604 1183.7 709.569 1189.4 702.1L1437.04 377.576C1440.18 373.457 1444.53 370.416 1449.48 368.874L1894.47 230.199C1900.76 228.239 1907.57 228.841 1913.42 231.875L2202.45 381.806Z",
    fill: "url(#paint0_linear_52_1131)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0289855,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1906.62 250.563L2185.14 414.679C2193.18 419.418 2197.13 428.895 2194.83 437.942L2115.23 751.262C2113.87 756.634 2110.43 761.249 2105.68 764.1L1709.64 1001.64C1705.89 1003.89 1701.54 1004.91 1697.19 1004.57L1293.73 972.857C1285.88 972.239 1279.03 967.273 1275.99 959.997L1167.44 699.449C1164.41 692.173 1165.71 683.813 1170.8 677.799L1432.39 369.005C1435.22 365.674 1439.01 363.305 1443.24 362.228L1890.78 248.304C1896.15 246.937 1901.85 247.749 1906.62 250.563ZM2187.17 411.233C2196.74 416.874 2201.44 428.157 2198.71 438.927L2119.11 752.247C2117.48 758.642 2113.39 764.136 2107.74 767.53L1711.7 1005.07C1707.24 1007.75 1702.06 1008.96 1696.88 1008.56L1293.42 976.844C1284.07 976.109 1275.91 970.197 1272.3 961.536L1163.75 700.987C1160.14 692.326 1161.69 682.373 1167.75 675.213L1429.34 366.42C1432.7 362.454 1437.21 359.634 1442.25 358.352L1889.79 244.428C1896.19 242.8 1902.97 243.766 1908.65 247.116L2187.17 411.233Z",
    fill: "url(#paint1_linear_52_1131)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0434783,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1900.86 266.443L2168.17 444.056C2175.92 449.208 2179.36 458.849 2176.61 467.744L2081.91 774.394C2080.28 779.698 2076.61 784.137 2071.7 786.742L1667.66 1001.42C1663.79 1003.47 1659.38 1004.27 1655.04 1003.69L1257.35 950.82C1249.55 949.783 1242.98 944.469 1240.34 937.054L1146.14 672.772C1143.5 665.357 1145.22 657.087 1150.61 651.348L1425.19 358.85C1428.19 355.657 1432.11 353.481 1436.4 352.627L1885.14 263.338C1890.58 262.254 1896.24 263.371 1900.86 266.443ZM2170.38 440.725C2179.61 446.858 2183.71 458.335 2180.44 468.924L2085.74 775.574C2083.79 781.888 2079.42 787.174 2073.58 790.274L1669.54 1004.95C1664.93 1007.4 1659.68 1008.34 1654.51 1007.66L1256.83 954.785C1247.54 953.55 1239.72 947.224 1236.57 938.397L1142.37 674.115C1139.22 665.288 1141.28 655.443 1147.69 648.611L1422.27 356.112C1425.84 352.311 1430.51 349.721 1435.62 348.704L1884.36 259.414C1890.84 258.125 1897.57 259.454 1903.07 263.111L2170.38 440.725Z",
    fill: "url(#paint2_linear_52_1131)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.057971,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1894.26 283.022L2149.73 473.412C2157.17 478.96 2160.09 488.736 2156.9 497.456L2047.58 796.721C2045.67 801.943 2041.77 806.195 2036.74 808.546L1625.99 1000.18C1622.01 1002.03 1617.55 1002.6 1613.23 1001.78L1222.41 928.271C1214.68 926.818 1208.42 921.172 1206.17 913.639L1126.41 646.406C1124.16 638.873 1126.31 630.716 1131.97 625.266L1418.57 349.571C1421.74 346.526 1425.78 344.55 1430.12 343.922L1878.71 279.077C1884.21 278.281 1889.81 279.7 1894.26 283.022ZM2152.12 470.205C2160.98 476.809 2164.45 488.448 2160.66 498.829L2051.34 798.093C2049.07 804.31 2044.42 809.373 2038.43 812.171L1627.68 1003.8C1622.94 1006.01 1617.63 1006.68 1612.49 1005.72L1221.67 932.202C1212.47 930.472 1205.01 923.751 1202.34 914.783L1122.58 647.55C1119.9 638.582 1122.46 628.871 1129.2 622.383L1415.8 346.689C1419.57 343.063 1424.38 340.711 1429.55 339.963L1878.14 275.118C1884.69 274.171 1891.35 275.86 1896.65 279.815L2152.12 470.205Z",
    fill: "url(#paint3_linear_52_1131)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0724638,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1886.8 300.247L2129.82 502.663C2136.94 508.588 2139.33 518.471 2135.72 526.995L2012.28 818.19C2010.11 823.316 2005.99 827.37 2000.83 829.459L1584.67 997.935C1580.59 999.589 1576.09 999.916 1571.81 998.869L1188.92 905.288C1181.29 903.425 1175.34 897.463 1173.49 889.833L1108.23 620.432C1106.38 612.802 1108.94 604.779 1114.87 599.631L1412.47 341.19C1415.8 338.301 1419.95 336.532 1424.34 336.133L1871.46 295.469C1877.01 294.965 1882.52 296.683 1886.8 300.247ZM2132.38 499.589C2140.85 506.643 2143.7 518.409 2139.4 528.556L2015.96 819.751C2013.38 825.854 2008.47 830.68 2002.33 833.167L1586.17 1001.64C1581.31 1003.61 1575.95 1004 1570.86 1002.76L1187.97 909.174C1178.89 906.955 1171.81 899.858 1169.6 890.775L1104.34 621.374C1102.14 612.291 1105.19 602.739 1112.24 596.611L1409.85 338.17C1413.81 334.731 1418.76 332.624 1423.98 332.149L1871.1 291.485C1877.7 290.885 1884.27 292.931 1889.36 297.173L2132.38 499.589Z",
    fill: "url(#paint4_linear_52_1131)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0869565,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1878.45 318.065L2108.47 531.729C2115.23 538.011 2117.1 547.974 2113.07 556.28L1976.06 838.754C1973.63 843.771 1969.3 847.615 1964.03 849.437L1543.75 994.719C1539.57 996.164 1535.05 996.253 1530.82 994.974L1156.87 881.953C1149.37 879.685 1143.75 873.426 1142.31 865.721L1091.54 594.93C1090.1 587.225 1093.07 579.357 1099.24 574.524L1406.85 333.73C1410.33 331.005 1414.58 329.448 1419 329.281L1863.36 312.466C1868.93 312.255 1874.36 314.269 1878.45 318.065ZM2111.19 528.798C2119.24 536.277 2121.47 548.138 2116.67 558.025L1979.66 840.499C1976.76 846.473 1971.61 851.048 1965.34 853.217L1545.06 998.5C1540.09 1000.22 1534.7 1000.33 1529.66 998.803L1155.72 885.782C1146.78 883.082 1140.1 875.631 1138.38 866.458L1087.61 595.667C1085.89 586.494 1089.42 577.127 1096.77 571.375L1404.38 330.58C1408.53 327.336 1413.59 325.483 1418.85 325.284L1863.21 308.469C1869.84 308.218 1876.3 310.616 1881.17 315.134L2111.19 528.798Z",
    fill: "url(#paint5_linear_52_1131)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.101449,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1869.18 336.424L2085.7 560.535C2092.1 567.154 2093.44 577.168 2089.01 585.235L1938.99 858.371C1936.3 863.267 1931.77 866.89 1926.41 868.438L1503.29 990.561C1499.03 991.791 1494.48 991.64 1490.31 990.131L1126.3 858.35C1118.94 855.686 1113.67 849.148 1112.63 841.388L1076.33 569.982C1075.29 562.223 1078.66 554.53 1085.06 550.025L1401.65 327.211C1405.27 324.658 1409.62 323.32 1414.05 323.386L1854.39 330.018C1859.98 330.102 1865.3 332.407 1869.18 336.424ZM2088.58 557.755C2096.19 565.636 2097.79 577.556 2092.51 587.161L1942.5 860.297C1939.3 866.125 1933.91 870.438 1927.52 872.281L1504.4 994.404C1499.32 995.868 1493.92 995.689 1488.95 993.892L1124.94 862.111C1116.17 858.939 1109.9 851.156 1108.67 841.919L1072.36 570.512C1071.13 561.275 1075.13 552.117 1082.75 546.754L1399.34 323.94C1403.66 320.901 1408.83 319.307 1414.11 319.387L1854.45 326.018C1861.1 326.118 1867.44 328.863 1872.06 333.645L2088.58 557.755Z",
    fill: "url(#paint6_linear_52_1131)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.115942,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1858.98 355.272L2061.54 589.005C2067.55 595.941 2068.36 605.976 2063.54 613.786L1901.12 877.002C1898.18 881.763 1893.47 885.155 1888.02 886.425L1463.31 985.491C1458.98 986.501 1454.44 986.11 1450.34 984.372L1097.18 834.56C1089.98 831.507 1085.08 824.71 1084.45 816.918L1062.53 545.663C1061.9 537.871 1065.66 530.375 1072.27 526.206L1396.81 321.649C1400.57 319.277 1404.99 318.161 1409.43 318.463L1844.53 348.074C1850.11 348.454 1855.31 351.045 1858.98 355.272ZM2064.56 586.385C2071.72 594.642 2072.68 606.589 2066.95 615.887L1904.52 879.103C1901.03 884.77 1895.41 888.808 1888.93 890.321L1464.22 989.386C1459.06 990.589 1453.66 990.123 1448.78 988.055L1095.62 838.242C1087.05 834.608 1081.21 826.516 1080.46 817.24L1058.55 545.985C1057.8 536.709 1062.26 527.785 1070.14 522.823L1394.68 318.265C1399.16 315.441 1404.42 314.113 1409.7 314.473L1844.8 344.083C1851.45 344.536 1857.64 347.62 1862 352.653L2064.56 586.385Z",
    fill: "url(#paint7_linear_52_1131)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.130435,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1847.82 374.554L2036.02 617.066C2041.63 624.295 2041.91 634.324 2036.72 641.858L1862.51 894.609C1859.33 899.222 1854.44 902.374 1848.92 903.362L1423.88 979.541C1419.48 980.328 1414.95 979.695 1410.94 977.733L1069.51 810.661C1062.5 807.231 1057.97 800.194 1057.75 792.392L1050.11 522.044C1049.89 514.242 1054.02 506.961 1060.82 503.14L1392.28 317.058C1396.17 314.872 1400.66 313.984 1405.09 314.522L1833.76 366.582C1839.32 367.257 1844.38 370.128 1847.82 374.554ZM2039.18 614.614C2045.86 623.22 2046.19 635.159 2040.01 644.128L1865.8 896.879C1862.02 902.371 1856.2 906.123 1849.63 907.3L1424.58 983.478C1419.35 984.416 1413.96 983.662 1409.18 981.326L1067.75 814.254C1059.41 810.17 1054.01 801.793 1053.75 792.505L1046.11 522.157C1045.85 512.869 1050.76 504.201 1058.86 499.652L1390.32 313.57C1394.95 310.968 1400.3 309.911 1405.57 310.552L1834.24 362.611C1840.86 363.415 1846.89 366.832 1850.98 372.102L2039.18 614.614Z",
    fill: "url(#paint8_linear_52_1131)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.144928,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1835.7 394.217L2009.18 644.65C2014.37 652.149 2014.13 662.144 2008.58 669.384L1823.23 911.162C1819.82 915.616 1814.76 918.518 1809.2 919.221L1385.03 972.75C1380.58 973.31 1376.08 972.436 1372.17 970.253L1043.3 786.737C1036.49 782.94 1032.35 775.685 1032.53 767.893L1039.02 499.199C1039.2 491.407 1043.69 484.36 1050.67 480.895L1388.01 313.448C1392.02 311.457 1396.56 310.8 1400.98 311.575L1822.07 385.491C1827.6 386.462 1832.51 389.604 1835.7 394.217ZM2012.47 642.372C2018.65 651.3 2018.36 663.199 2011.76 671.818L1826.41 913.596C1822.34 918.898 1816.33 922.353 1809.7 923.189L1385.53 976.718C1380.24 977.386 1374.87 976.344 1370.22 973.746L1041.35 790.23C1033.24 785.709 1028.31 777.072 1028.54 767.797L1035.02 499.102C1035.24 489.826 1040.58 481.437 1048.89 477.312L1386.23 309.865C1391.01 307.495 1396.42 306.713 1401.67 307.635L1822.76 381.552C1829.34 382.707 1835.19 386.448 1838.99 391.939L2012.47 642.372Z",
    fill: "url(#paint9_linear_52_1131)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15942,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1822.61 414.205L1981.05 671.687C1985.82 679.432 1985.06 689.366 1979.17 696.294L1783.34 926.631C1779.7 930.913 1774.5 933.557 1768.89 933.971L1346.8 965.152C1342.31 965.483 1337.84 964.367 1334.04 961.969L1018.51 762.863C1011.93 758.711 1008.18 751.259 1008.78 743.499L1029.18 477.189C1029.78 469.43 1034.61 462.636 1041.75 459.534L1383.94 310.826C1388.06 309.035 1392.65 308.613 1397.03 309.623L1809.44 404.748C1814.92 406.011 1819.66 409.417 1822.61 414.205ZM1984.46 669.59C1990.13 678.811 1989.23 690.637 1982.21 698.885L1786.39 929.222C1782.06 934.32 1775.86 937.468 1769.18 937.961L1347.09 969.141C1341.75 969.535 1336.43 968.207 1331.91 965.351L1016.37 766.246C1008.54 761.302 1004.08 752.431 1004.79 743.194L1025.19 476.884C1025.9 467.646 1031.66 459.558 1040.16 455.865L1382.34 307.158C1387.25 305.025 1392.71 304.523 1397.92 305.726L1810.34 400.85C1816.86 402.354 1822.51 406.409 1826.01 412.108L1984.46 669.59Z",
    fill: "url(#paint10_linear_52_1131)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.173913,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1808.53 434.462L1951.69 698.111C1956.01 706.079 1954.74 715.923 1948.52 722.525L1742.91 940.989C1739.05 945.089 1733.7 947.468 1728.08 947.592L1309.22 956.787C1304.71 956.886 1300.29 955.531 1296.61 952.922L995.138 739.117C988.8 734.622 985.462 726.995 986.46 719.289L1020.56 456.079C1021.56 448.374 1026.73 441.849 1034 439.118L1380.01 309.195C1384.23 307.61 1388.85 307.426 1393.19 308.671L1795.87 424.299C1801.28 425.853 1805.84 429.514 1808.53 434.462ZM1955.2 696.203C1960.35 705.688 1958.83 717.407 1951.44 725.266L1745.82 943.731C1741.23 948.612 1734.86 951.444 1728.16 951.591L1309.31 960.786C1303.94 960.904 1298.68 959.291 1294.3 956.185L992.824 742.38C985.279 737.029 981.305 727.949 982.493 718.775L1016.59 455.565C1017.78 446.392 1023.94 438.624 1032.6 435.373L1378.6 305.451C1383.63 303.563 1389.13 303.344 1394.29 304.826L1796.97 420.454C1803.42 422.304 1808.85 426.663 1812.04 432.554L1955.2 696.203Z",
    fill: "url(#paint11_linear_52_1131)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.188406,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1793.46 454.937L1921.13 723.864C1925 732.028 1923.22 741.756 1916.7 748.016L1701.99 954.219C1697.93 958.125 1692.46 960.231 1686.82 960.063L1272.34 947.698C1267.82 947.563 1263.46 945.97 1259.91 943.156L973.16 715.574C967.084 710.751 964.161 702.971 965.559 695.34L1013.08 435.929C1014.48 428.298 1019.97 422.059 1027.37 419.704L1376.17 308.559C1380.49 307.185 1385.13 307.24 1389.4 308.718L1781.35 444.094C1786.68 445.935 1791.05 449.843 1793.46 454.937ZM1924.74 722.149C1929.35 731.868 1927.23 743.449 1919.47 750.901L1704.76 957.104C1699.92 961.754 1693.41 964.262 1686.7 964.061L1272.22 951.696C1266.84 951.536 1261.65 949.639 1257.42 946.29L970.674 718.707C963.44 712.966 959.96 703.704 961.625 694.62L1009.15 435.208C1010.81 426.124 1017.35 418.697 1026.15 415.893L1374.96 304.747C1380.09 303.112 1385.62 303.178 1390.71 304.937L1782.65 440.313C1789 442.505 1794.2 447.157 1797.08 453.222L1924.74 722.149Z",
    fill: "url(#paint12_linear_52_1131)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.202899,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1777.41 475.573L1889.42 748.884C1892.83 757.219 1890.55 766.804 1883.75 772.708L1660.66 966.3C1656.4 970.002 1650.82 971.83 1645.19 971.369L1236.18 937.925C1231.65 937.555 1227.37 935.727 1223.97 932.715L952.545 692.306C946.747 687.17 944.246 679.26 946.039 671.725L1006.69 416.79C1008.48 409.255 1014.27 403.318 1021.76 401.344L1372.37 308.912C1376.76 307.754 1381.41 308.051 1385.62 309.759L1765.87 464.078C1771.11 466.202 1775.26 470.346 1777.41 475.573ZM1893.12 747.367C1897.19 757.29 1894.47 768.701 1886.37 775.729L1663.28 969.321C1658.21 973.729 1651.56 975.904 1644.86 975.356L1235.85 941.912C1230.46 941.471 1225.36 939.295 1221.31 935.709L949.893 695.3C942.99 689.186 940.013 679.77 942.147 670.8L1002.8 415.864C1004.93 406.894 1011.83 399.827 1020.74 397.476L1371.35 305.044C1376.58 303.665 1382.11 304.019 1387.12 306.053L1767.37 460.372C1773.61 462.901 1778.56 467.833 1781.11 474.056L1893.12 747.367Z",
    fill: "url(#paint13_linear_52_1131)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.217391,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1760.37 496.317L1856.63 773.117C1859.58 781.597 1856.81 791.014 1849.74 796.549L1619 977.22C1614.54 980.709 1608.87 982.252 1603.26 981.5L1200.78 927.513C1196.26 926.907 1192.06 924.847 1188.82 921.645L933.274 669.385C927.771 663.953 925.698 655.936 927.879 648.517L1001.31 398.715C1003.49 391.296 1009.58 385.677 1017.14 384.087L1368.55 310.251C1373.01 309.314 1377.65 309.853 1381.78 311.789L1749.45 484.202C1754.57 486.604 1758.51 490.972 1760.37 496.317ZM1860.4 771.803C1863.92 781.899 1860.62 793.109 1852.2 799.699L1621.46 980.37C1616.16 984.523 1609.4 986.36 1602.73 985.464L1200.25 931.478C1194.87 930.756 1189.87 928.304 1186.01 924.491L930.464 672.232C923.913 665.765 921.445 656.221 924.042 647.389L997.476 397.587C1000.07 388.755 1007.31 382.065 1016.32 380.172L1367.73 306.336C1373.04 305.22 1378.57 305.863 1383.48 308.167L1751.15 480.58C1757.25 483.44 1761.93 488.641 1764.14 495.003L1860.4 771.803Z",
    fill: "url(#paint14_linear_52_1131)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.231884,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1742.34 517.115L1822.79 796.51C1825.27 805.109 1822.02 814.333 1814.71 819.487L1577.05 986.97C1572.41 990.235 1566.66 991.489 1561.08 990.446L1166.15 916.507C1161.66 915.665 1157.56 913.377 1154.48 909.991L915.302 646.879C910.11 641.167 908.47 633.066 911.031 625.784L996.882 381.75C999.444 374.468 1005.79 369.178 1013.42 367.975L1364.65 312.567C1369.17 311.854 1373.8 312.637 1377.83 314.796L1732.07 504.412C1737.07 507.087 1740.77 511.668 1742.34 517.115ZM1826.64 795.404C1829.58 805.64 1825.72 816.62 1817.01 822.757L1579.35 990.24C1573.83 994.127 1566.98 995.619 1560.35 994.377L1165.42 920.438C1160.06 919.436 1155.18 916.712 1151.52 912.682L912.342 649.57C906.161 642.769 904.208 633.126 907.258 624.457L993.109 380.422C996.158 371.753 1003.72 365.456 1012.8 364.024L1364.03 308.616C1369.41 307.767 1374.92 308.699 1379.72 311.27L1733.96 500.885C1739.91 504.07 1744.32 509.524 1746.18 516.009L1826.64 795.404Z",
    fill: "url(#paint15_linear_52_1131)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.246377,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1723.33 537.916L1787.98 819.016C1789.97 827.707 1786.27 836.712 1778.73 841.476L1534.88 995.544C1530.08 998.576 1524.26 999.536 1518.74 998.204L1132.33 904.952C1127.87 903.874 1123.88 901.363 1120.98 897.802L898.596 624.854C893.729 618.88 892.524 610.719 895.459 603.594L993.325 365.937C996.259 358.811 1002.86 353.865 1010.52 353.05L1360.63 315.85C1365.19 315.365 1369.79 316.39 1373.72 318.769L1713.75 524.658C1718.6 527.599 1722.06 532.382 1723.33 537.916ZM1791.87 818.12C1794.25 828.466 1789.84 839.187 1780.86 844.857L1537.02 998.925C1531.31 1002.54 1524.37 1003.68 1517.8 1002.09L1131.4 908.84C1126.08 907.558 1121.33 904.568 1117.88 900.329L895.495 627.381C889.7 620.269 888.267 610.554 891.76 602.071L989.626 364.413C993.12 355.93 1000.98 350.042 1010.1 349.073L1360.2 311.872C1365.64 311.295 1371.12 312.515 1375.79 315.347L1715.82 521.237C1721.6 524.738 1725.72 530.432 1727.23 537.019L1791.87 818.12Z",
    fill: "url(#paint16_linear_52_1131)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26087,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1703.36 558.667L1752.24 840.591C1753.76 849.347 1749.6 858.11 1741.86 862.473L1492.58 1002.94C1487.63 1005.73 1481.75 1006.39 1476.3 1004.78L1099.34 892.897C1094.92 891.585 1091.06 888.855 1088.34 885.129L883.118 603.375C878.589 597.157 877.822 588.96 881.12 582.01L990.572 351.314C993.87 344.363 1000.7 339.772 1008.38 339.347L1356.42 320.086C1361.03 319.832 1365.59 321.099 1369.4 323.692L1694.49 544.892C1699.19 548.092 1702.39 553.063 1703.36 558.667ZM1756.18 839.907C1757.99 850.331 1753.04 860.764 1743.82 865.958L1494.54 1006.42C1488.65 1009.75 1481.65 1010.54 1475.16 1008.61L1098.2 896.732C1092.94 895.17 1088.34 891.92 1085.11 887.484L879.885 605.73C874.493 598.328 873.58 588.569 877.506 580.295L986.958 349.599C990.884 341.325 999.019 335.859 1008.16 335.353L1356.2 316.092C1361.68 315.789 1367.11 317.298 1371.65 320.385L1696.74 541.585C1702.33 545.394 1706.15 551.312 1707.3 557.984L1756.18 839.907Z",
    fill: "url(#paint17_linear_52_1131)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.275362,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1682.44 579.318L1715.64 861.191C1716.68 869.986 1712.09 878.485 1704.16 882.439L1450.2 1009.16C1445.1 1011.7 1439.19 1012.07 1433.82 1010.17L1067.2 880.388C1062.83 878.844 1059.1 875.901 1056.59 872.018L868.824 582.501C864.646 576.058 864.318 567.849 867.968 561.093L988.548 337.914C992.198 331.158 999.245 326.933 1006.92 326.896L1351.99 325.259C1356.62 325.237 1361.13 326.744 1364.81 329.547L1674.3 565.064C1678.83 568.514 1681.77 573.659 1682.44 579.318ZM1719.62 860.723C1720.85 871.193 1715.38 881.311 1705.95 886.018L1451.99 1012.74C1445.92 1015.77 1438.88 1016.2 1432.48 1013.94L1065.86 884.159C1060.67 882.32 1056.23 878.818 1053.23 874.195L865.468 584.678C860.494 577.008 860.103 567.234 864.449 559.191L985.029 336.012C989.374 327.969 997.763 322.94 1006.91 322.896L1351.97 321.259C1357.48 321.232 1362.85 323.027 1367.23 326.364L1676.72 561.88C1682.12 565.988 1685.62 572.114 1686.41 578.85L1719.62 860.723Z",
    fill: "url(#paint18_linear_52_1131)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.289855,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1660.57 599.817L1678.25 880.78C1678.8 889.586 1673.79 897.799 1665.71 901.337L1407.81 1014.21C1402.58 1016.5 1396.65 1016.56 1391.37 1014.38L1035.91 867.472C1031.62 865.698 1028.03 862.549 1025.72 858.519L855.667 562.288C851.851 555.64 851.96 547.441 855.951 540.897L987.175 325.763C991.167 319.219 998.407 315.37 1006.06 315.72L1347.28 331.345C1351.92 331.557 1356.36 333.303 1359.9 336.309L1653.2 585.122C1657.55 588.815 1660.22 594.12 1660.57 599.817ZM1682.24 880.529C1682.9 891.012 1676.94 900.79 1667.32 905.001L1409.41 1017.87C1403.19 1020.6 1396.12 1020.67 1389.84 1018.07L1034.38 871.169C1029.27 869.056 1025.01 865.308 1022.25 860.511L852.198 564.279C847.655 556.365 847.784 546.605 852.536 538.814L983.76 323.68C988.512 315.89 997.131 311.307 1006.25 311.725L1347.46 327.349C1352.99 327.602 1358.27 329.68 1362.49 333.259L1655.79 582.072C1660.97 586.468 1664.14 592.784 1664.57 599.566L1682.24 880.529Z",
    fill: "url(#paint19_linear_52_1131)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.304348,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1637.78 620.121L1640.12 899.327C1640.19 908.118 1634.79 916.024 1626.56 919.14L1365.47 1018.1C1360.13 1020.12 1354.18 1019.88 1349.02 1017.43L1005.5 854.202C1001.29 852.2 997.861 848.852 995.762 844.687L843.595 542.793C840.151 535.961 840.696 527.797 845.016 521.482L986.376 314.89C990.696 308.576 998.109 305.111 1005.72 305.846L1342.24 338.328C1346.88 338.776 1351.24 340.758 1354.63 343.96L1631.2 605.026C1635.36 608.951 1637.74 614.403 1637.78 620.121ZM1644.12 899.293C1644.21 909.759 1637.77 919.171 1627.98 922.88L1366.89 1021.84C1360.52 1024.25 1353.45 1023.96 1347.3 1021.04L1003.78 857.815C998.769 855.432 994.689 851.446 992.19 846.487L840.023 544.594C835.923 536.46 836.571 526.741 841.715 519.224L983.075 312.632C988.218 305.115 997.043 300.99 1006.11 301.865L1342.62 334.347C1348.15 334.88 1353.34 337.239 1357.38 341.051L1633.95 602.117C1638.9 606.79 1641.73 613.28 1641.78 620.088L1644.12 899.293Z",
    fill: "url(#paint20_linear_52_1131)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.318841,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1614.1 640.18L1601.33 916.8C1600.93 925.549 1595.14 933.129 1586.8 935.818L1323.26 1020.83C1317.81 1022.59 1311.87 1022.05 1306.83 1019.33L975.984 840.625C971.863 838.399 968.604 834.859 966.726 830.568L832.567 524.066C829.505 517.07 830.481 508.964 835.118 502.896L986.082 305.313C990.718 299.245 998.283 296.172 1005.84 297.288L1336.82 346.181C1341.46 346.865 1345.73 349.079 1348.96 352.47L1608.33 624.727C1612.28 628.875 1614.36 634.457 1614.1 640.18ZM1605.33 916.985C1604.85 927.4 1597.95 936.424 1588.03 939.625L1324.49 1024.64C1318 1026.74 1310.93 1026.09 1304.93 1022.85L974.083 844.144C969.177 841.494 965.297 837.28 963.062 832.172L828.902 525.67C825.257 517.342 826.42 507.691 831.939 500.467L982.903 302.884C988.422 295.661 997.428 292.002 1006.42 293.331L1337.41 342.224C1342.92 343.039 1348.01 345.674 1351.86 349.711L1611.22 621.968C1615.93 626.906 1618.41 633.552 1618.1 640.365L1605.33 916.985Z",
    fill: "url(#paint21_linear_52_1131)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.333333,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1589.53 659.949L1561.94 933.175C1561.06 941.856 1554.91 949.091 1546.48 951.349L1281.22 1022.44C1275.68 1023.93 1269.77 1023.08 1264.87 1020.1L947.353 826.789C943.336 824.343 940.256 820.62 938.607 816.215L822.514 506.154C819.841 499.016 821.246 490.991 826.184 485.185L986.2 297.045C991.138 291.239 998.834 288.565 1006.31 290.057L1330.98 354.876C1335.6 355.797 1339.76 358.239 1342.82 361.812L1584.59 644.181C1588.32 648.541 1590.11 654.238 1589.53 659.949ZM1565.92 933.577C1564.87 943.912 1557.55 952.524 1547.51 955.213L1282.26 1026.31C1275.66 1028.07 1268.62 1027.07 1262.79 1023.51L945.273 830.205C940.49 827.294 936.824 822.861 934.861 817.618L818.768 507.556C815.586 499.059 817.258 489.505 823.137 482.593L983.153 294.453C989.031 287.542 998.193 284.358 1007.09 286.134L1331.77 350.953C1337.26 352.05 1342.22 354.957 1345.86 359.21L1587.63 641.579C1592.07 646.769 1594.2 653.553 1593.51 660.351L1565.92 933.577Z",
    fill: "url(#paint22_linear_52_1131)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.347826,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1564.11 679.385L1522.01 948.432C1520.67 957.018 1514.18 963.89 1505.68 965.716L1239.44 1022.94C1233.82 1024.15 1227.94 1023 1223.19 1019.76L919.629 812.745C915.727 810.084 912.836 806.185 911.422 801.679L813.395 489.102C811.119 481.843 812.945 473.922 818.17 468.393L986.668 290.098C991.892 284.57 999.698 282.299 1007.07 284.162L1324.69 364.385C1329.27 365.542 1333.32 368.208 1336.2 371.953L1560.02 663.346C1563.52 667.907 1565 673.704 1564.11 679.385ZM1525.96 949.05C1524.37 959.272 1516.63 967.453 1506.52 969.627L1240.28 1026.85C1233.59 1028.29 1226.6 1026.92 1220.94 1023.06L917.375 816.049C912.73 812.882 909.288 808.241 907.606 802.876L809.578 490.298C806.868 481.658 809.043 472.228 815.263 465.646L983.76 287.351C989.98 280.769 999.273 278.066 1008.05 280.284L1325.67 360.507C1331.12 361.884 1335.94 365.058 1339.37 369.517L1563.19 660.91C1567.36 666.339 1569.12 673.24 1568.06 680.003L1525.96 949.05Z",
    fill: "url(#paint23_linear_52_1131)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.362319,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1537.87 698.445L1481.63 962.55C1479.82 971.017 1473.01 977.51 1464.47 978.902L1197.96 1022.34C1192.27 1023.27 1186.45 1021.82 1181.87 1018.33L892.808 798.539C889.032 795.669 886.34 791.604 885.169 787.008L805.146 472.948C803.272 465.592 805.513 457.796 811.009 452.56L987.4 284.477C992.896 279.24 1000.79 277.377 1008.05 279.604L1317.88 374.675C1322.42 376.066 1326.35 378.951 1329.03 382.861L1534.64 682.181C1537.9 686.93 1539.07 692.81 1537.87 698.445ZM1485.54 963.383C1483.39 973.462 1475.28 981.192 1465.11 982.85L1198.6 1026.29C1191.83 1027.4 1184.91 1025.67 1179.45 1021.52L890.386 801.724C885.892 798.306 882.687 793.467 881.292 787.996L801.27 473.935C799.039 465.178 801.707 455.898 808.25 449.664L984.641 281.581C991.183 275.347 1000.58 273.129 1009.22 275.78L1319.06 370.851C1324.46 372.507 1329.13 375.942 1332.33 380.596L1537.93 679.916C1541.82 685.569 1543.21 692.57 1541.78 699.278L1485.54 963.383Z",
    fill: "url(#paint24_linear_52_1131)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.376812,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1510.82 717.092L1440.84 975.519C1438.59 983.842 1431.48 989.941 1422.91 990.9L1156.83 1020.69C1151.1 1021.33 1145.35 1019.58 1140.94 1015.86L866.886 784.225C863.248 781.15 860.764 776.93 859.84 772.257L797.705 457.732C796.236 450.3 798.885 442.654 804.635 437.722L988.317 280.186C994.067 275.254 1002.03 273.802 1009.15 276.385L1310.54 385.715C1315.01 387.339 1318.81 390.438 1321.29 394.502L1508.47 700.649C1511.48 705.573 1512.33 711.52 1510.82 717.092ZM1444.7 976.565C1442.02 986.472 1433.55 993.733 1423.35 994.875L1157.28 1024.66C1150.45 1025.43 1143.61 1023.35 1138.36 1018.91L864.304 787.28C859.973 783.62 857.015 778.595 855.916 773.032L793.78 458.508C792.033 449.66 795.185 440.557 802.031 434.686L985.713 277.15C992.559 271.278 1002.04 269.549 1010.51 272.625L1311.9 381.954C1317.23 383.888 1321.75 387.577 1324.7 392.415L1511.88 698.562C1515.46 704.425 1516.48 711.504 1514.68 718.137L1444.7 976.565Z",
    fill: "url(#paint25_linear_52_1131)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.391304,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1483 735.286L1399.73 987.33C1397.03 995.483 1389.65 1001.17 1381.08 1001.7L1116.13 1018C1110.36 1018.36 1104.7 1016.32 1100.48 1012.36L841.865 769.848C838.375 766.576 836.107 762.209 835.437 757.472L791.012 443.487C789.953 436.002 792.999 428.525 798.987 423.911L989.344 277.219C995.332 272.605 1003.34 271.565 1010.31 274.497L1302.6 397.467C1307.01 399.322 1310.66 402.628 1312.93 406.837L1481.54 718.711C1484.29 723.798 1484.82 729.794 1483 735.286ZM1403.53 988.585C1400.32 998.291 1391.53 1005.07 1381.32 1005.69L1116.38 1021.99C1109.51 1022.42 1102.76 1019.99 1097.74 1015.28L839.129 772.766C834.974 768.87 832.275 763.672 831.477 758.032L787.052 444.047C785.791 435.136 789.417 426.235 796.545 420.742L986.902 274.051C994.031 268.558 1003.56 267.32 1011.86 270.81L1304.16 393.78C1309.41 395.989 1313.74 399.924 1316.45 404.935L1485.06 716.808C1488.33 722.865 1488.96 730.003 1486.8 736.541L1403.53 988.585Z",
    fill: "url(#paint26_linear_52_1131)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.405797,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1454.46 752.991L1358.36 997.976C1355.24 1005.94 1347.6 1011.21 1339.05 1011.31L1075.91 1014.31C1070.11 1014.38 1064.55 1012.05 1060.53 1007.87L817.745 755.457C814.413 751.993 812.37 747.491 811.957 742.703L785.013 430.239C784.365 422.724 787.797 415.438 794.005 411.153L990.41 275.57C996.617 271.285 1004.65 270.658 1011.44 273.928L1294.06 409.894C1298.39 411.978 1301.88 415.484 1303.94 419.827L1453.89 736.332C1456.37 741.568 1456.57 747.597 1454.46 752.991ZM1362.08 999.437C1358.37 1008.91 1349.27 1015.19 1339.1 1015.31L1075.95 1018.31C1069.06 1018.39 1062.43 1015.62 1057.65 1010.65L814.862 758.23C810.895 754.106 808.464 748.747 807.972 743.047L781.027 430.583C780.256 421.636 784.342 412.963 791.732 407.861L988.137 272.278C995.527 267.176 1005.09 266.43 1013.18 270.324L1295.8 406.29C1300.95 408.77 1305.1 412.944 1307.55 418.114L1457.5 734.619C1460.46 740.853 1460.7 748.03 1458.18 754.452L1362.08 999.437Z",
    fill: "url(#paint27_linear_52_1131)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42029,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1425.21 770.177L1316.8 1007.46C1313.26 1015.2 1305.39 1020.04 1296.89 1019.72L1036.2 1009.66C1030.4 1009.44 1024.95 1006.82 1021.15 1002.44L794.505 741.099C791.342 737.452 789.532 732.826 789.38 728L779.631 418.018C779.395 410.495 783.202 403.421 789.611 399.475L991.428 275.228C997.837 271.282 1005.87 271.068 1012.48 274.667L1284.86 422.959C1289.1 425.268 1292.42 428.966 1294.25 433.433L1425.53 753.48C1427.74 758.852 1427.62 764.896 1425.21 770.177ZM1320.43 1009.12C1316.22 1018.34 1306.86 1024.1 1296.73 1023.71L1036.05 1013.66C1029.14 1013.39 1022.66 1010.28 1018.13 1005.06L791.483 743.72C787.718 739.378 785.563 733.871 785.382 728.126L775.633 418.144C775.351 409.188 779.884 400.766 787.514 396.069L989.331 271.822C996.961 267.124 1006.52 266.869 1014.39 271.154L1286.78 419.446C1291.82 422.194 1295.77 426.598 1297.95 431.915L1429.23 751.962C1431.86 758.357 1431.72 765.552 1428.84 771.839L1320.43 1009.12Z",
    fill: "url(#paint28_linear_52_1131)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.434783,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1395.29 786.806L1275.11 1015.78C1271.17 1023.28 1263.11 1027.68 1254.66 1026.93L997.081 1004.08C991.287 1003.57 985.965 1000.67 982.385 996.088L772.148 726.818C769.164 722.995 767.594 718.256 767.706 713.407L774.816 406.84C774.99 399.333 779.159 392.49 785.751 388.893L992.337 276.173C998.929 272.576 1006.94 272.773 1013.35 276.69L1274.99 436.617C1279.13 439.146 1282.26 443.03 1283.86 447.609L1396.52 770.121C1398.44 775.613 1398 781.655 1395.29 786.806ZM1278.65 1017.63C1273.96 1026.57 1264.36 1031.81 1254.31 1030.92L996.728 1008.07C989.83 1007.45 983.494 1004.01 979.232 998.55L768.996 729.279C765.442 724.728 763.574 719.087 763.708 713.315L770.817 406.748C771.024 397.81 775.988 389.663 783.836 385.381L990.421 272.662C998.269 268.38 1007.81 268.614 1015.43 273.277L1277.08 433.204C1282 436.215 1285.74 440.839 1287.64 446.29L1400.3 768.802C1402.58 775.34 1402.05 782.533 1398.83 788.665L1278.65 1017.63Z",
    fill: "url(#paint29_linear_52_1131)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.449275,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1364.75 802.856L1233.37 1022.94C1229.05 1030.19 1220.8 1034.14 1212.44 1032.97L958.581 997.619C952.807 996.815 947.628 993.647 944.282 988.874L750.657 712.663C747.859 708.673 746.537 703.834 746.916 698.976L770.496 396.729C771.079 389.26 775.597 382.667 782.353 379.427L993.059 278.391C999.815 275.151 1007.78 275.757 1013.97 279.979L1264.41 450.831C1268.44 453.577 1271.38 457.638 1272.74 462.317L1366.88 786.231C1368.51 791.829 1367.74 797.851 1364.75 802.856ZM1236.81 1024.99C1231.66 1033.62 1221.84 1038.32 1211.89 1036.94L958.029 1001.58C951.156 1000.62 944.99 996.852 941.006 991.17L747.381 714.959C744.051 710.209 742.477 704.448 742.928 698.664L766.509 396.418C767.202 387.526 772.581 379.677 780.623 375.82L991.33 274.784C999.372 270.928 1008.86 271.648 1016.23 276.675L1266.66 447.526C1271.46 450.796 1274.96 455.63 1276.58 461.201L1370.72 785.115C1372.66 791.779 1371.74 798.948 1368.18 804.906L1236.81 1024.99Z",
    fill: "url(#paint30_linear_52_1131)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.463768,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1333.62 818.296L1191.64 1028.95C1186.94 1035.92 1178.55 1039.42 1170.3 1037.85L920.747 990.311C915.009 989.218 909.985 985.785 906.883 980.836L730.014 698.676C727.413 694.527 726.344 689.6 726.992 684.747L766.608 387.695C767.596 380.287 772.448 373.961 779.348 371.087L993.524 281.854C1000.42 278.979 1008.33 279.988 1014.29 284.504L1253.1 465.553C1257 468.511 1259.74 472.74 1260.86 477.508L1336.65 801.78C1337.98 807.468 1336.88 813.452 1333.62 818.296ZM1194.96 1031.19C1189.37 1039.48 1179.37 1043.65 1169.55 1041.78L919.998 994.24C913.167 992.939 907.187 988.852 903.494 982.96L726.625 700.801C723.529 695.862 722.256 689.996 723.027 684.218L762.643 387.167C763.82 378.347 769.595 370.817 777.809 367.394L991.985 278.161C1000.2 274.739 1009.61 275.941 1016.7 281.316L1255.51 462.366C1260.16 465.887 1263.43 470.922 1264.75 476.598L1340.54 800.87C1342.13 807.641 1340.82 814.765 1336.93 820.531L1194.96 1031.19Z",
    fill: "url(#paint31_linear_52_1131)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.478261,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1301.92 833.103L1149.97 1033.84C1144.93 1040.51 1136.41 1043.55 1128.28 1041.57L883.617 982.207C877.929 980.827 873.075 977.135 870.225 972.022L710.2 684.902C707.805 680.604 706.995 675.601 707.911 670.766L763.083 379.751C764.472 372.425 769.641 366.385 776.665 363.881L993.658 286.535C1000.68 284.032 1008.51 285.44 1014.22 290.236L1241.02 480.742C1244.79 483.907 1247.33 488.294 1248.19 493.138L1305.86 816.745C1306.88 822.507 1305.46 828.437 1301.92 833.103ZM1153.16 1036.25C1147.16 1044.19 1137.01 1047.81 1127.34 1045.46L882.674 986.094C875.902 984.451 870.124 980.056 866.731 973.97L706.706 686.849C703.855 681.732 702.89 675.777 703.981 670.021L759.153 379.005C760.806 370.284 766.96 363.094 775.322 360.113L992.315 282.767C1000.68 279.787 1009.99 281.464 1016.79 287.173L1243.6 477.679C1248.08 481.447 1251.1 486.67 1252.13 492.437L1309.79 816.043C1311.02 822.903 1309.32 829.962 1305.11 835.518L1153.16 1036.25Z",
    fill: "url(#paint32_linear_52_1131)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.492754,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1269.73 847.254L1108.46 1037.61C1103.08 1043.96 1094.45 1046.53 1086.47 1044.17L847.244 973.351C841.62 971.686 836.949 967.745 834.36 962.481L691.21 671.379C689.028 666.942 688.482 661.876 689.668 657.076L759.87 372.899C761.654 365.679 767.124 359.94 774.251 357.813L993.411 292.402C1000.54 290.275 1008.26 292.077 1013.71 297.139L1228.18 496.35C1231.81 499.716 1234.13 504.252 1234.73 509.159L1274.55 831.102C1275.27 836.923 1273.52 842.779 1269.73 847.254ZM1111.51 1040.2C1105.1 1047.76 1094.84 1050.82 1085.34 1048.01L846.109 977.186C839.413 975.204 833.852 970.512 830.771 964.247L687.621 673.144C685.023 667.862 684.373 661.832 685.784 656.117L755.986 371.94C758.11 363.344 764.622 356.512 773.107 353.98L992.267 288.569C1000.75 286.037 1009.94 288.182 1016.43 294.208L1230.9 493.42C1235.22 497.426 1237.98 502.826 1238.7 508.668L1278.52 830.611C1279.38 837.54 1277.3 844.513 1272.78 849.84L1111.51 1040.2Z",
    fill: "url(#paint33_linear_52_1131)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.507246,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1237.07 860.733L1067.13 1040.29C1061.44 1046.3 1052.74 1048.41 1044.93 1045.67L811.655 963.795C806.109 961.849 801.633 957.667 799.313 952.267L673.012 658.152C671.051 653.586 670.774 648.471 672.228 643.719L756.895 367.147C759.067 360.053 764.821 354.632 772.031 352.885L992.708 299.423C999.918 297.676 1007.52 299.863 1012.69 305.177L1214.55 512.334C1218.02 515.894 1220.11 520.568 1220.46 525.526L1242.77 844.834C1243.18 850.697 1241.11 856.464 1237.07 860.733ZM1070.04 1043.04C1063.26 1050.2 1052.91 1052.71 1043.6 1049.44L810.33 967.57C803.728 965.253 798.399 960.274 795.638 953.845L669.337 659.731C667.002 654.294 666.672 648.206 668.404 642.548L753.07 365.976C755.656 357.531 762.505 351.077 771.089 348.997L991.766 295.535C1000.35 293.456 1009.39 296.06 1015.56 302.385L1217.41 509.543C1221.54 513.78 1224.04 519.345 1224.45 525.248L1246.76 844.555C1247.25 851.535 1244.79 858.401 1239.98 863.482L1070.04 1043.04Z",
    fill: "url(#paint34_linear_52_1131)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.521739,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1203.97 873.519L1026.06 1041.9C1020.07 1047.56 1011.33 1049.2 1003.7 1046.09L776.876 953.589C771.422 951.365 767.153 946.953 765.11 941.428L655.579 645.258C653.846 640.572 653.84 635.422 655.563 630.733L754.09 362.492C756.642 355.546 762.66 350.455 769.933 349.092L991.484 307.557C998.757 306.193 1006.21 308.758 1011.1 314.308L1200.1 528.645C1203.41 532.392 1205.27 537.194 1205.35 542.189L1210.54 857.922C1210.63 863.811 1208.25 869.47 1203.97 873.519ZM1028.81 1044.8C1021.68 1051.55 1011.27 1053.5 1002.19 1049.79L775.366 957.293C768.873 954.645 763.791 949.392 761.358 942.816L651.827 646.645C649.764 641.067 649.757 634.937 651.808 629.354L750.336 361.113C753.373 352.844 760.538 346.784 769.196 345.16L990.747 303.625C999.405 302.002 1008.28 305.055 1014.1 311.662L1203.1 526C1207.04 530.46 1209.25 536.177 1209.35 542.124L1214.53 857.856C1214.65 864.867 1211.82 871.604 1206.72 876.424L1028.81 1044.8Z",
    fill: "url(#paint35_linear_52_1131)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.536232,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1170.49 885.599L985.303 1042.46C979.046 1047.76 970.275 1048.94 962.845 1045.47L742.944 942.784C737.595 940.287 733.545 935.654 731.785 930.02L638.89 632.732C637.392 627.939 637.661 622.768 639.649 618.156L751.398 358.927C754.319 352.15 760.584 347.404 767.898 346.426L989.686 316.761C997 315.783 1004.29 318.716 1008.89 324.487L1184.84 545.235C1187.97 549.162 1189.59 554.081 1189.4 559.099L1177.9 870.35C1177.68 876.249 1174.99 881.784 1170.49 885.599ZM987.889 1045.52C980.439 1051.83 969.998 1053.22 961.152 1049.09L741.251 946.409C734.884 943.436 730.062 937.92 727.967 931.213L635.072 633.925C633.289 628.219 633.609 622.063 635.976 616.572L747.725 357.344C751.203 349.276 758.66 343.626 767.368 342.461L989.155 312.796C997.863 311.632 1006.54 315.123 1012.02 321.994L1187.97 542.742C1191.69 547.417 1193.62 553.273 1193.4 559.247L1181.9 870.498C1181.64 877.52 1178.44 884.109 1173.07 888.651L987.889 1045.52Z",
    fill: "url(#paint36_linear_52_1131)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.550725,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1136.66 896.96L944.919 1042.02C938.412 1046.94 929.644 1047.65 922.432 1043.83L709.888 931.435C704.659 928.669 700.838 923.827 699.366 918.097L622.923 620.612C621.666 615.722 622.213 610.543 624.464 606.024L748.761 356.447C752.042 349.859 758.532 345.47 765.867 344.877L987.262 326.993C994.598 326.4 1001.71 329.691 1006 335.667L1168.75 562.057C1171.7 566.156 1173.07 571.18 1172.61 576.209L1144.91 882.107C1144.38 887.998 1141.38 893.391 1136.66 896.96ZM947.332 1045.21C939.586 1051.07 929.148 1051.91 920.562 1047.37L708.018 934.971C701.793 931.679 697.245 925.914 695.492 919.093L619.049 621.608C617.553 615.786 618.204 609.621 620.884 604.241L745.18 354.664C749.086 346.821 756.812 341.595 765.545 340.89L986.94 323.006C995.673 322.3 1004.14 326.218 1009.25 333.332L1172 559.722C1175.51 564.602 1177.14 570.583 1176.6 576.569L1148.89 882.467C1148.26 889.481 1144.69 895.901 1139.08 900.15L947.332 1045.21Z",
    fill: "url(#paint37_linear_52_1131)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.565217,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1102.54 907.594L904.955 1040.6C898.223 1045.13 889.482 1045.37 882.504 1041.23L677.727 919.596C672.63 916.568 669.05 911.527 667.871 905.717L607.644 608.931C606.635 603.956 607.461 598.784 609.971 594.372L746.113 355.039C749.742 348.66 756.437 344.638 763.773 344.431L984.157 338.204C991.493 337.997 998.405 341.635 1002.39 347.799L1151.82 579.063C1154.58 583.327 1155.7 588.444 1154.97 593.468L1111.6 893.181C1110.75 899.049 1107.46 904.284 1102.54 907.594ZM907.189 1043.91C899.174 1049.31 888.768 1049.6 880.462 1044.67L675.685 923.035C669.617 919.431 665.355 913.43 663.951 906.513L603.724 609.727C602.522 603.804 603.506 597.647 606.495 592.394L742.636 353.061C746.956 345.467 754.927 340.679 763.66 340.432L984.044 334.206C992.777 333.959 1001.01 338.29 1005.75 345.628L1155.18 576.892C1158.46 581.968 1159.79 588.06 1158.93 594.041L1115.55 893.754C1114.54 900.739 1110.63 906.971 1104.77 910.912L907.189 1043.91Z",
    fill: "url(#paint38_linear_52_1131)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57971,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1068.15 917.492L865.464 1038.23C858.529 1042.36 849.84 1042.15 843.112 1037.69L646.481 907.322C641.529 904.038 638.2 898.811 637.318 892.935L593.024 597.721C592.267 592.672 593.374 587.521 596.139 583.23L743.395 354.688C747.359 348.536 754.239 344.892 761.555 345.068L980.32 350.345C987.635 350.521 994.332 354.493 997.994 360.829L1134.06 596.205C1136.62 600.624 1137.47 605.823 1136.47 610.829L1078 903.564C1076.83 909.391 1073.26 914.452 1068.15 917.492ZM867.511 1041.67C859.255 1046.58 848.911 1046.34 840.902 1041.03L644.271 910.656C638.376 906.747 634.412 900.524 633.362 893.529L589.069 598.314C588.167 592.304 589.485 586.172 592.776 581.064L740.033 352.521C744.751 345.198 752.942 340.859 761.651 341.069L980.416 346.346C989.125 346.556 997.097 351.285 1001.46 358.827L1137.52 594.203C1140.56 599.464 1141.59 605.653 1140.4 611.612L1081.92 904.348C1080.53 911.284 1076.28 917.309 1070.2 920.929L867.511 1041.67Z",
    fill: "url(#paint39_linear_52_1131)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.594203,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1033.55 926.652L826.495 1034.96C819.381 1038.68 810.769 1038.02 804.306 1033.26L616.169 894.671C611.375 891.139 608.305 885.738 607.724 879.811L579.034 587.012C578.534 581.903 579.922 576.787 582.936 572.632L740.553 355.377C744.838 349.472 751.88 346.213 759.155 346.771L975.709 363.364C982.984 363.921 989.448 368.215 992.783 374.704L1115.46 613.437C1117.81 618.002 1118.4 623.27 1117.13 628.243L1044.16 913.253C1042.68 919.022 1038.83 923.892 1033.55 926.652ZM828.349 1038.51C819.881 1042.94 809.628 1042.15 801.933 1036.48L613.797 897.891C608.089 893.687 604.435 887.256 603.743 880.201L575.053 587.402C574.457 581.32 576.11 575.23 579.699 570.283L737.315 353.028C742.416 345.998 750.8 342.119 759.461 342.782L976.014 359.376C984.675 360.039 992.37 365.151 996.34 372.876L1119.02 611.608C1121.81 617.044 1122.52 623.314 1121 629.235L1048.04 914.245C1046.28 921.113 1041.69 926.911 1035.4 930.197L828.349 1038.51Z",
    fill: "url(#paint40_linear_52_1131)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.608696,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M998.769 935.07L788.085 1030.83C780.818 1034.14 772.306 1033.03 766.121 1027.99L586.796 881.698C582.171 877.925 579.37 872.363 579.093 866.401L565.633 576.831C565.393 571.673 567.062 566.608 570.32 562.603L737.522 357.084C742.113 351.442 749.296 348.576 756.51 349.511L970.274 377.205C977.487 378.139 983.704 382.74 986.705 389.366L1096.01 630.708C1098.14 635.412 1098.47 640.735 1096.92 645.661L1010.12 922.241C1008.33 927.936 1004.2 932.601 998.769 935.07ZM789.74 1034.48C781.089 1038.41 770.956 1037.1 763.592 1031.09L584.267 884.798C578.762 880.306 575.427 873.684 575.097 866.587L561.637 577.017C561.352 570.877 563.338 564.847 567.218 560.079L734.419 354.56C739.884 347.842 748.436 344.432 757.024 345.544L970.787 373.238C979.375 374.35 986.776 379.828 990.349 387.716L1099.66 629.058C1102.19 634.657 1102.58 640.994 1100.74 646.859L1013.93 923.439C1011.8 930.218 1006.89 935.772 1000.42 938.712L789.74 1034.48Z",
    fill: "url(#paint41_linear_52_1131)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.623188,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M963.859 942.745L750.288 1025.88C742.892 1028.76 734.504 1027.23 728.609 1021.91L558.382 868.46C553.939 864.454 551.415 858.744 551.443 852.762L552.798 567.204C552.823 562.01 554.771 557.01 558.266 553.169L734.259 359.784C739.14 354.421 746.442 351.955 753.575 353.262L963.987 391.81C971.119 393.117 977.073 398.011 979.736 404.756L1075.74 647.973C1077.65 652.803 1077.7 658.17 1075.88 663.035L975.913 930.527C973.818 936.131 969.434 940.575 963.859 942.745ZM751.739 1029.61C742.934 1033.04 732.949 1031.21 725.931 1024.88L555.704 871.431C550.414 866.663 547.409 859.865 547.443 852.743L548.798 567.185C548.827 561.002 551.147 555.049 555.308 550.477L731.301 357.092C737.111 350.707 745.805 347.772 754.296 349.328L964.707 387.876C973.199 389.432 980.287 395.258 983.456 403.288L1079.46 646.504C1081.73 652.255 1081.79 658.643 1079.63 664.435L979.659 931.927C977.166 938.598 971.947 943.889 965.31 946.473L751.739 1029.61Z",
    fill: "url(#paint42_linear_52_1131)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.637681,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M928.855 949.682L713.133 1020.16C705.633 1022.61 697.392 1020.65 691.799 1015.09L530.925 855.016C526.675 850.787 524.435 844.943 524.77 838.956L540.484 558.156C540.776 552.939 543.002 548.019 546.728 544.355L730.704 363.452C735.857 358.384 743.256 356.323 750.287 357.996L956.804 407.125C963.836 408.798 969.513 413.97 971.833 420.816L1054.64 665.185C1056.31 670.134 1056.09 675.529 1054 680.319L941.582 938.114C939.185 943.61 934.554 947.82 928.855 949.682ZM714.375 1023.96C705.447 1026.88 695.636 1024.55 688.978 1017.92L528.104 857.851C523.044 852.817 520.377 845.859 520.776 838.733L536.491 557.932C536.838 551.722 539.488 545.864 543.923 541.503L727.899 360.6C734.035 354.566 742.842 352.113 751.213 354.104L957.729 403.234C966.101 405.225 972.859 411.382 975.621 419.532L1058.43 663.901C1060.42 669.792 1060.15 676.216 1057.66 681.918L945.249 939.713C942.396 946.256 936.882 951.267 930.097 953.484L714.375 1023.96Z",
    fill: "url(#paint43_linear_52_1131)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.652174,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M893.8 955.883L676.662 1013.71C669.083 1015.73 661.011 1013.36 655.731 1007.56L504.432 841.421C500.386 836.978 498.437 831.014 499.079 825.038L528.661 549.707C529.223 544.48 531.724 539.654 535.671 536.182L726.809 368.056C732.219 363.298 739.69 361.645 746.602 363.676L948.698 423.087C955.61 425.119 960.998 430.552 962.972 437.48L1032.72 682.298C1034.16 687.354 1033.65 692.766 1031.29 697.465L907.168 945.004C904.474 950.376 899.607 954.337 893.8 955.883ZM677.691 1017.58C668.669 1019.98 659.06 1017.16 652.773 1010.25L501.475 844.115C496.658 838.825 494.337 831.725 495.102 824.611L524.684 549.28C525.352 543.057 528.33 537.312 533.029 533.179L724.168 365.052C730.607 359.388 739.502 357.42 747.73 359.839L949.827 419.249C958.055 421.668 964.469 428.136 966.819 436.384L1036.56 681.203C1038.28 687.221 1037.67 693.664 1034.87 699.258L910.743 946.797C907.536 953.192 901.743 957.907 894.829 959.749L677.691 1017.58Z",
    fill: "url(#paint44_linear_52_1131)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.666667,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.742 961.356L640.913 1006.58C633.281 1008.17 625.4 1005.4 620.441 999.382L478.909 827.732C475.077 823.084 473.425 817.014 474.374 811.065L517.297 541.875C518.13 536.652 520.904 531.935 525.064 528.667L722.536 373.563C728.182 369.128 735.703 367.885 742.476 370.268L939.65 439.633C946.423 442.016 951.509 447.694 953.135 454.687L1010 699.266C1011.2 704.419 1010.41 709.833 1007.79 714.428L872.713 951.2C869.728 956.432 864.64 960.131 858.742 961.356ZM641.726 1010.5C632.641 1012.39 623.258 1009.09 617.355 1001.93L475.823 830.276C471.261 824.743 469.295 817.517 470.424 810.436L513.347 541.246C514.339 535.027 517.641 529.411 522.593 525.522L720.065 370.417C726.787 365.137 735.74 363.658 743.804 366.494L940.977 435.859C949.04 438.696 955.096 445.456 957.031 453.781L1013.9 698.36C1015.32 704.494 1014.38 710.94 1011.26 716.41L876.187 953.182C872.634 959.411 866.576 963.814 859.555 965.272L641.726 1010.5Z",
    fill: "url(#paint45_linear_52_1131)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.681159,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M823.707 966.112L605.905 998.83C598.246 999.981 590.575 996.822 585.947 990.611L454.342 814.008C450.734 809.166 449.385 803.006 450.638 797.099L506.344 534.683C507.45 529.476 510.492 524.883 514.855 521.833L717.826 379.943C723.69 375.844 731.238 375.012 737.854 377.737L929.623 456.706C936.239 459.431 941.012 465.336 942.289 472.377L986.487 716.049C987.437 721.287 986.362 726.691 983.48 731.166L838.244 956.714C834.975 961.791 829.679 965.215 823.707 966.112ZM606.499 1002.79C597.381 1004.16 588.249 1000.39 582.739 993.001L451.135 816.398C446.839 810.634 445.233 803.3 446.726 796.269L502.432 533.853C503.748 527.653 507.369 522.185 512.563 518.554L715.534 376.665C722.515 371.784 731.501 370.795 739.377 374.038L931.146 453.008C939.022 456.251 944.705 463.282 946.225 471.663L990.422 715.335C991.553 721.571 990.274 728.004 986.843 733.332L841.607 958.88C837.715 964.923 831.41 969 824.302 970.067L606.499 1002.79Z",
    fill: "url(#paint46_linear_52_1131)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.695652,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M788.738 970.16L571.667 990.498C564.006 991.216 556.565 987.686 552.275 981.298L430.725 800.303C427.351 795.278 426.308 789.041 427.866 783.192L495.767 528.142C497.145 522.964 500.451 518.509 505.007 515.689L712.639 387.156C718.701 383.403 726.253 382.982 732.694 386.038L918.6 474.24C925.042 477.296 929.492 483.411 930.42 490.48L962.199 732.601C962.896 737.913 961.536 743.291 958.398 747.634L803.8 961.552C800.254 966.458 794.765 969.595 788.738 970.16ZM572.04 994.481C562.919 995.335 554.061 991.133 548.954 983.528L427.405 802.533C423.387 796.551 422.146 789.126 424 782.163L491.901 527.113C493.543 520.949 497.478 515.645 502.901 512.287L710.534 383.754C717.751 379.287 726.741 378.786 734.409 382.424L920.315 470.626C927.983 474.264 933.282 481.544 934.386 489.96L966.165 732.08C966.995 738.404 965.376 744.807 961.64 749.977L807.042 963.895C802.821 969.735 796.286 973.47 789.111 974.142L572.04 994.481Z",
    fill: "url(#paint47_linear_52_1131)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.710145,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M753.875 973.513L538.227 981.641C530.588 981.929 523.396 978.044 519.45 971.497L408.053 786.67C404.921 781.474 404.19 775.176 406.048 769.4L485.53 522.264C487.182 517.129 490.746 512.826 495.483 510.248L706.942 395.162C713.181 391.766 720.713 391.755 726.962 395.131L906.571 492.171C912.82 495.547 916.939 501.854 917.519 508.934L937.159 748.879C937.599 754.255 935.953 759.594 932.564 763.789L769.419 965.725C765.606 970.444 759.938 973.284 753.875 973.513ZM538.378 985.639C529.284 985.981 520.722 981.356 516.025 973.561L404.628 788.735C400.899 782.549 400.028 775.052 402.24 768.176L481.722 521.039C483.688 514.926 487.931 509.804 493.571 506.735L705.029 391.648C712.457 387.606 721.424 387.592 728.864 391.612L908.472 488.652C915.912 492.671 920.815 500.179 921.505 508.607L941.145 748.553C941.669 754.952 939.711 761.308 935.675 766.303L772.531 968.238C767.991 973.857 761.244 977.238 754.026 977.51L538.378 985.639Z",
    fill: "url(#paint48_linear_52_1131)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.724638,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M719.152 976.187L505.602 972.314C498.011 972.177 491.085 967.952 487.489 961.266L386.311 773.166C383.43 767.81 383.012 761.467 385.167 755.779L475.593 517.061C477.517 511.983 481.333 507.847 486.241 505.522L700.692 403.922C707.087 400.893 714.578 401.287 720.619 404.972L893.52 510.436C899.562 514.121 903.341 520.601 903.574 527.673L911.386 764.846C911.565 770.273 909.634 775.559 905.999 779.593L735.134 969.247C731.063 973.766 725.233 976.297 719.152 976.187ZM505.53 976.314C496.492 976.15 488.248 971.121 483.966 963.161L382.788 775.061C379.358 768.684 378.861 761.133 381.426 754.362L471.853 515.644C474.143 509.599 478.686 504.675 484.528 501.907L698.98 400.308C706.593 396.701 715.51 397.171 722.702 401.557L895.603 507.021C902.795 511.408 907.294 519.122 907.571 527.541L915.384 764.714C915.597 771.175 913.298 777.468 908.971 782.271L738.106 971.924C733.26 977.304 726.319 980.318 719.079 980.186L505.53 976.314Z",
    fill: "url(#paint49_linear_52_1131)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73913,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.607 978.2L473.813 962.57C466.294 962.013 459.651 957.467 456.408 950.661L365.486 759.843C362.864 754.338 362.763 747.966 365.21 742.381L465.922 512.542C468.117 507.534 472.178 503.579 477.243 501.518L693.862 413.395C700.391 410.739 707.817 411.535 713.634 415.516L879.446 528.972C885.263 532.952 888.695 539.585 888.585 546.633L884.909 780.462C884.823 785.929 882.608 791.147 878.735 795.007L700.983 972.133C696.664 976.436 690.688 978.651 684.607 978.2ZM473.518 966.559C464.566 965.896 456.658 960.484 452.797 952.381L361.875 761.563C358.753 755.011 358.633 747.424 361.546 740.776L462.259 510.937C464.871 504.974 469.706 500.266 475.736 497.813L692.355 409.69C700.128 406.528 708.968 407.476 715.893 412.214L881.705 525.67C888.63 530.409 892.716 538.306 892.584 546.696L888.909 780.525C888.806 787.033 886.169 793.246 881.558 797.84L703.807 974.966C698.665 980.09 691.55 982.726 684.312 982.189L473.518 966.559Z",
    fill: "url(#paint50_linear_52_1131)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.753623,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M650.266 979.569L442.865 952.463C435.442 951.493 429.097 946.645 426.211 939.738L345.552 746.751C343.194 741.111 343.411 734.724 346.146 729.258L456.468 508.712C458.932 503.787 463.232 500.027 468.441 498.242L686.411 423.535C693.052 421.259 700.391 422.451 705.969 426.714L864.334 547.713C869.912 551.975 872.992 558.742 872.541 565.748L857.744 795.689C857.39 801.185 854.892 806.321 850.788 809.993L666.988 974.398C662.432 978.473 656.327 980.361 650.266 979.569ZM442.347 956.429C433.51 955.274 425.957 949.503 422.52 941.28L341.861 748.293C339.055 741.579 339.313 733.976 342.569 727.468L452.891 506.923C455.824 501.06 460.943 496.583 467.144 494.458L685.114 419.751C693.02 417.041 701.757 418.461 708.398 423.535L866.763 544.534C873.403 549.608 877.07 557.665 876.533 566.005L861.736 795.946C861.315 802.488 858.341 808.604 853.454 812.974L669.655 977.379C664.231 982.23 656.963 984.478 649.748 983.535L442.347 956.429Z",
    fill: "url(#paint51_linear_52_1131)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.768116,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.167 980.314L412.773 942.046C405.471 940.672 399.438 935.541 396.909 928.554L326.491 733.94C324.406 728.178 324.942 721.793 327.958 716.459L447.2 505.576C449.93 500.748 454.459 497.195 459.799 495.695L678.316 434.297C685.047 432.406 692.277 433.988 697.602 438.517L848.192 566.596C853.517 571.125 856.239 578.008 855.453 584.954L829.925 810.493C829.301 816.005 826.522 821.046 822.195 824.516L633.186 976.06C628.405 979.894 622.189 981.447 616.167 980.314ZM412.034 945.977C403.34 944.342 396.158 938.233 393.148 929.915L322.729 735.301C320.247 728.442 320.885 720.84 324.476 714.49L443.718 503.607C446.968 497.859 452.36 493.63 458.717 491.844L677.234 430.446C685.247 428.195 693.854 430.078 700.194 435.47L850.783 563.549C857.123 568.941 860.364 577.134 859.428 585.404L833.9 810.943C833.157 817.505 829.849 823.506 824.697 827.636L635.688 979.181C629.997 983.744 622.596 985.594 615.427 984.245L412.034 945.977Z",
    fill: "url(#paint52_linear_52_1131)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.782609,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.338 980.458L383.544 931.375C376.384 929.607 370.676 924.213 368.507 917.164L308.278 721.459C306.471 715.587 307.326 709.219 310.617 704.032L438.076 503.134C441.069 498.416 445.82 495.085 451.276 493.879L669.552 445.634C676.349 444.132 683.449 446.095 688.508 450.877L831.021 585.558C836.08 590.339 838.441 597.317 837.325 604.188L801.481 824.84C800.585 830.355 797.528 835.286 792.986 838.541L599.605 977.139C594.612 980.718 588.302 981.931 582.338 980.458ZM382.585 935.259C374.061 933.154 367.266 926.732 364.684 918.341L304.455 722.635C302.304 715.646 303.322 708.064 307.239 701.889L434.698 500.991C438.262 495.374 443.917 491.409 450.413 489.973L668.689 441.729C676.781 439.94 685.233 442.278 691.256 447.97L833.768 582.651C839.791 588.343 842.602 596.649 841.273 604.829L805.429 825.481C804.363 832.047 800.723 837.917 795.316 841.792L601.935 980.391C595.991 984.651 588.479 986.095 581.379 984.342L382.585 935.259Z",
    fill: "url(#paint53_linear_52_1131)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.797101,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.803 980.024L355.174 920.503C348.179 918.353 342.808 912.716 340.997 905.626L290.882 709.353C289.358 703.386 290.531 697.05 294.089 692.023L429.054 501.386C432.307 496.791 437.269 493.695 442.826 492.792L660.091 457.501C666.932 456.389 673.88 458.725 678.661 463.742L812.824 604.536C817.605 609.554 819.602 616.607 818.163 623.386L772.437 838.697C771.268 844.204 767.936 849.011 763.189 852.039L566.267 977.655C561.074 980.967 554.69 981.833 548.803 980.024ZM353.999 924.327C345.672 921.767 339.277 915.057 337.122 906.615L287.006 710.343C285.192 703.238 286.588 695.696 290.825 689.712L425.789 499.075C429.662 493.605 435.569 489.918 442.185 488.844L659.45 453.552C667.594 452.229 675.865 455.01 681.557 460.983L815.719 601.777C821.411 607.75 823.789 616.146 822.075 624.217L776.35 839.528C774.958 846.084 770.991 851.807 765.34 855.411L568.418 981.028C562.236 984.971 554.636 986.001 547.627 983.847L353.999 924.327Z",
    fill: "url(#paint54_linear_52_1131)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.811594,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.595 979.038L327.671 909.488C320.862 906.968 315.838 901.11 314.385 893.996L274.277 697.67C273.041 691.62 274.531 685.333 278.349 680.481L420.101 500.334C423.61 495.875 428.773 493.026 434.416 492.434L649.92 469.851C656.781 469.132 663.558 471.828 668.049 477.065L793.618 623.474C798.109 628.71 799.742 635.819 797.986 642.49L742.833 852.038C741.389 857.525 737.786 862.194 732.844 864.982L533.204 977.633C527.826 980.668 521.386 981.182 515.595 979.038ZM326.283 913.239C318.177 910.239 312.196 903.265 310.466 894.797L270.358 698.471C268.887 691.269 270.66 683.784 275.205 678.007L416.958 497.86C421.134 492.552 427.281 489.16 433.999 488.456L649.503 465.872C657.671 465.017 665.739 468.227 671.085 474.461L796.654 620.87C802.001 627.104 803.944 635.566 801.854 643.508L746.701 853.056C744.982 859.588 740.693 865.146 734.81 868.466L535.17 981.117C528.768 984.729 521.1 985.341 514.207 982.79L326.283 913.239Z",
    fill: "url(#paint55_linear_52_1131)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.826087,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.742 977.524L301.032 898.377C294.431 895.501 289.762 889.444 288.664 882.327L258.435 686.448C257.491 680.33 259.294 674.106 263.363 669.441L411.183 499.967C414.942 495.658 420.296 493.067 426.008 492.795L639.025 482.632C645.883 482.305 652.468 485.351 656.659 490.79L773.419 642.305C777.61 647.744 778.878 654.888 776.814 661.437L712.704 864.831C710.984 870.285 707.115 874.802 701.99 877.339L500.443 977.092C494.894 979.838 488.417 979.996 482.742 977.524ZM299.435 902.044C291.576 898.621 286.018 891.409 284.711 882.937L254.482 687.058C253.358 679.774 255.504 672.366 260.349 666.812L408.168 497.338C412.643 492.208 419.017 489.124 425.817 488.799L638.834 478.637C646.999 478.247 654.838 481.874 659.828 488.348L776.588 639.864C781.577 646.338 783.086 654.843 780.629 662.639L716.519 866.034C714.472 872.527 709.866 877.904 703.764 880.924L502.217 980.677C495.612 983.946 487.901 984.134 481.144 981.191L299.435 902.044Z",
    fill: "url(#paint56_linear_52_1131)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84058,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.262 975.509L275.248 887.225C268.873 884.009 264.568 877.774 263.821 870.672L243.316 675.728C242.667 669.555 244.781 663.411 249.092 658.946L402.258 500.282C406.262 496.134 411.795 493.815 417.56 493.868L627.389 495.797C634.221 495.859 640.596 499.242 644.478 504.866L752.243 660.974C756.125 666.597 757.028 673.757 754.665 680.168L682.082 877.053C680.088 882.462 675.958 886.813 670.66 889.087L468.002 976.057C462.298 978.505 455.804 978.304 450.262 975.509ZM273.447 890.796C265.857 886.968 260.733 879.545 259.843 871.091L239.338 676.146C238.565 668.798 241.082 661.484 246.214 656.168L399.38 497.503C404.147 492.566 410.734 489.805 417.597 489.868L627.425 491.797C635.559 491.872 643.148 495.899 647.769 502.593L755.535 658.701C760.156 665.395 761.231 673.919 758.418 681.551L685.835 878.436C683.461 884.876 678.544 890.056 672.237 892.763L469.579 979.733C462.789 982.647 455.058 982.408 448.461 979.08L273.447 890.796Z",
    fill: "url(#paint57_linear_52_1131)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.855072,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.173 973.022L250.303 876.085C244.173 872.544 240.239 866.154 239.838 859.086L228.879 665.549C228.527 659.336 230.949 653.286 235.491 649.033L393.285 501.27C397.528 497.296 403.228 495.26 409.028 495.644L614.996 509.298C621.779 509.747 627.926 513.453 631.49 519.242L730.105 679.424C733.669 685.213 734.21 692.369 731.557 698.629L650.999 888.68C648.73 894.032 644.345 898.204 638.886 900.203L435.897 974.555C430.053 976.695 423.562 976.133 418.173 973.022ZM248.303 879.549C241.005 875.334 236.321 867.726 235.845 859.312L224.885 665.775C224.466 658.378 227.349 651.177 232.757 646.113L390.551 498.35C395.602 493.62 402.388 491.195 409.293 491.653L615.261 505.306C623.336 505.842 630.653 510.253 634.896 517.145L733.511 677.327C737.754 684.219 738.398 692.738 735.239 700.19L654.681 890.241C651.981 896.612 646.76 901.579 640.262 903.959L437.272 978.311C430.316 980.859 422.588 980.19 416.172 976.485L248.303 879.549Z",
    fill: "url(#paint58_linear_52_1131)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.869565,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.502 970.091L226.194 865.006C220.326 861.159 216.767 854.636 216.708 847.62L215.094 655.946C215.041 649.707 217.766 643.767 222.529 639.737L384.238 502.921C388.714 499.134 394.568 497.391 400.386 498.112L601.849 523.086C608.561 523.918 614.461 527.931 617.7 533.868L707.038 697.6C710.277 703.537 710.459 710.67 707.526 716.764L619.501 899.692C616.959 904.975 612.324 908.954 606.718 910.669L404.156 972.611C398.189 974.435 391.72 973.512 386.502 970.091ZM224.001 868.351C217.016 863.772 212.778 856.006 212.708 847.653L211.094 655.979C211.032 648.552 214.275 641.481 219.946 636.683L381.655 499.867C386.982 495.359 393.952 493.284 400.878 494.143L602.341 519.116C610.331 520.106 617.355 524.884 621.212 531.952L710.549 695.684C714.405 702.752 714.622 711.244 711.131 718.499L623.105 901.427C620.079 907.716 614.562 912.453 607.888 914.494L405.325 976.436C398.222 978.608 390.521 977.509 384.309 973.437L224.001 868.351Z",
    fill: "url(#paint59_linear_52_1131)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.884058,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.262 966.746L202.9 854.036C197.311 849.901 194.13 843.268 194.406 836.321L201.916 646.95C202.164 640.699 205.186 634.884 210.159 631.089L375.078 505.222C379.778 501.634 385.774 500.195 391.591 501.257L587.939 537.111C594.556 538.319 600.194 542.624 603.103 548.69L683.065 715.448C685.974 721.513 685.801 728.605 682.6 734.521L587.621 910.07C584.808 915.271 579.931 919.044 574.191 920.463L372.791 970.25C366.718 971.751 360.292 970.467 355.262 966.746ZM200.522 857.252C193.868 852.33 190.081 844.433 190.409 836.163L197.919 646.792C198.214 639.35 201.812 632.428 207.732 627.909L372.651 502.042C378.247 497.771 385.384 496.057 392.309 497.322L588.658 533.176C596.535 534.614 603.247 539.739 606.709 546.96L686.672 713.719C690.134 720.939 689.928 729.381 686.118 736.424L591.14 911.973C587.79 918.165 581.985 922.657 575.151 924.346L373.751 974.133C366.521 975.921 358.871 974.391 352.883 969.962L200.522 857.252Z",
    fill: "url(#paint60_linear_52_1131)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.898551,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.473 963.018L180.407 843.224C175.111 838.821 172.311 832.1 172.914 825.24L189.307 638.593C189.856 632.345 193.169 626.669 198.34 623.118L365.774 508.159C370.692 504.782 376.815 503.656 382.612 505.063L573.269 551.326C579.769 552.903 585.129 557.483 587.702 563.657L658.221 732.918C660.794 739.092 660.271 746.123 656.813 751.849L555.404 919.796C552.32 924.903 547.21 928.458 541.349 929.572L341.821 967.501C335.659 968.672 329.296 967.028 324.473 963.018ZM177.849 846.3C171.545 841.058 168.212 833.057 168.929 824.89L185.322 638.243C185.976 630.805 189.92 624.047 196.076 619.821L363.51 504.861C369.365 500.841 376.653 499.501 383.555 501.176L574.212 547.439C581.95 549.317 588.331 554.768 591.394 562.119L661.914 731.379C664.976 738.73 664.354 747.1 660.238 753.916L558.828 921.864C555.157 927.944 549.073 932.175 542.096 933.501L342.568 971.431C335.233 972.825 327.657 970.867 321.916 966.093L177.849 846.3Z",
    fill: "url(#paint61_linear_52_1131)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.913043,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.146 958.936L158.69 832.616C153.702 827.964 151.284 821.179 152.205 814.421L177.221 630.902C178.07 624.67 181.668 619.147 187.024 615.852L356.292 511.717C361.42 508.562 367.655 507.76 373.415 509.514L557.837 565.683C564.199 567.621 569.267 572.457 571.5 578.722L632.537 749.96C634.77 756.225 633.904 763.176 630.202 768.701L522.887 928.858C519.536 933.86 514.199 937.182 508.232 937.982L311.259 964.391C305.026 965.227 298.746 963.225 294.146 958.936ZM155.962 835.541C150.024 830.003 147.145 821.926 148.241 813.881L173.257 630.362C174.268 622.943 178.551 616.368 184.928 612.445L354.196 508.31C360.301 504.554 367.724 503.599 374.58 505.688L559.003 561.857C566.576 564.164 572.61 569.921 575.268 577.378L636.305 748.617C638.963 756.075 637.932 764.35 633.525 770.927L526.21 931.085C522.22 937.039 515.867 940.994 508.763 941.947L311.791 968.356C304.37 969.351 296.894 966.967 291.418 961.861L155.962 835.541Z",
    fill: "url(#paint62_linear_52_1131)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.927536,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.293 954.532L137.727 822.255C133.058 817.376 131.021 810.55 132.251 803.91L165.613 623.901C166.762 617.701 170.636 612.345 176.166 609.314L346.602 515.879C351.931 512.958 358.264 512.488 363.965 514.591L541.65 580.137C547.852 582.425 552.614 587.499 554.505 593.833L606.048 766.531C607.939 772.865 606.737 779.72 602.803 785.032L490.11 937.244C486.494 942.128 480.94 945.206 474.882 945.684L281.115 960.949C274.829 961.445 268.652 959.089 264.293 954.532ZM134.836 825.021C129.279 819.212 126.853 811.086 128.318 803.181L161.68 623.172C163.048 615.791 167.66 609.415 174.243 605.806L344.679 512.372C351.023 508.894 358.562 508.335 365.349 510.839L543.034 576.384C550.418 579.108 556.087 585.149 558.338 592.689L609.881 765.387C612.132 772.928 610.701 781.088 606.018 787.413L493.325 939.624C489.02 945.439 482.408 949.103 475.196 949.671L281.429 964.937C273.946 965.527 266.593 962.722 261.403 957.298L134.836 825.021Z",
    fill: "url(#paint63_linear_52_1131)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.942029,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.922 949.838L117.49 812.185C113.152 807.1 111.494 800.255 113.023 793.749L154.436 617.613C155.884 611.458 160.027 606.282 165.716 603.523L336.673 520.626C342.193 517.949 348.609 517.82 354.232 520.273L524.714 594.64C530.735 597.267 535.18 602.559 536.727 608.944L578.794 782.584C580.34 788.969 578.81 795.709 574.659 800.8L457.114 944.945C453.237 949.7 447.474 952.521 441.341 952.668L251.4 957.203C245.079 957.354 239.026 954.648 234.922 949.838ZM114.446 814.781C109.283 808.728 107.308 800.578 109.129 792.833L150.543 616.697C152.265 609.37 157.198 603.208 163.971 599.924L334.928 517.027C341.5 513.84 349.137 513.687 355.831 516.607L526.313 590.974C533.481 594.1 538.773 600.401 540.615 608.002L582.681 781.643C584.523 789.243 582.701 797.268 577.759 803.328L460.214 947.473C455.599 953.134 448.738 956.492 441.436 956.667L251.495 961.202C243.97 961.381 236.765 958.161 231.879 952.434L114.446 814.781Z",
    fill: "url(#paint64_linear_52_1131)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.956522,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.047 944.884L97.9549 802.443C93.9576 797.176 92.6748 790.333 94.4926 783.975L143.65 612.054C145.392 605.959 149.796 600.977 155.631 598.498L326.481 525.937C332.183 523.515 338.665 523.735 344.19 526.538L507.043 609.147C512.863 612.1 516.98 617.591 518.183 624.006L550.818 798.08C552.02 804.495 550.172 811.105 545.816 815.965L423.945 951.953C419.81 956.567 413.848 959.12 407.656 958.928L222.125 953.179C215.788 952.983 209.879 949.934 206.047 944.884ZM94.7685 804.861C90.0098 798.59 88.4827 790.444 90.6468 782.876L139.804 610.955C141.879 603.698 147.121 597.767 154.068 594.817L324.917 522.255C331.706 519.372 339.422 519.634 346 522.971L508.852 605.58C515.782 609.095 520.683 615.632 522.114 623.269L554.749 797.343C556.181 804.98 553.98 812.849 548.795 818.635L426.924 954.623C422.001 960.116 414.904 963.155 407.532 962.926L222.001 957.177C214.457 956.944 207.423 953.314 202.861 947.302L94.7685 804.861Z",
    fill: "url(#paint65_linear_52_1131)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.971014,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.663 939.705L79.0823 793.072C75.4333 787.645 74.5214 780.827 76.6157 774.631L133.195 607.245C135.231 601.223 139.885 596.447 145.852 594.256L315.989 531.794C321.864 529.637 328.395 530.213 333.802 533.365L488.641 623.619C494.242 626.884 498.021 632.552 498.88 638.978L522.154 812.984C523.013 819.41 520.857 825.872 516.311 830.494L390.634 958.268C386.245 962.73 380.095 965.002 373.86 964.465L193.288 948.911C186.955 948.366 181.209 944.981 177.663 939.705ZM75.7627 795.304C71.4187 788.843 70.3331 780.726 72.8263 773.35L129.406 605.964C131.829 598.795 137.369 593.11 144.473 590.502L314.61 528.039C321.604 525.471 329.379 526.157 335.816 529.909L490.655 620.163C497.323 624.05 501.822 630.798 502.845 638.448L526.119 812.454C527.142 820.103 524.575 827.797 519.163 833.299L393.486 961.073C388.261 966.385 380.94 969.09 373.517 968.45L192.945 952.896C185.405 952.247 178.565 948.217 174.343 941.937L75.7627 795.304Z",
    fill: "url(#paint66_linear_52_1131)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.985507,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.788 934.326L60.8531 784.101C57.559 778.537 57.012 771.765 59.3703 765.745L123.039 603.192C125.363 597.258 130.258 592.7 136.343 590.803L305.186 538.168C311.223 536.286 317.787 537.224 323.054 540.723L469.537 638.006C474.899 641.568 478.332 647.392 478.85 653.809L492.861 827.254C493.38 833.671 490.926 839.971 486.205 844.347L357.237 963.881C352.599 968.18 346.271 970.16 340.01 969.271L164.908 944.42C158.597 943.524 153.035 939.811 149.788 934.326ZM57.4111 786.139C53.4895 779.515 52.8383 771.454 55.6458 764.286L119.314 601.734C122.082 594.668 127.908 589.242 135.152 586.984L303.996 534.349C311.183 532.109 318.996 533.226 325.267 537.391L471.75 634.674C478.134 638.914 482.22 645.848 482.837 653.487L496.848 826.932C497.465 834.571 494.545 842.071 488.924 847.281L359.956 966.815C354.435 971.932 346.902 974.289 339.448 973.231L164.345 948.38C156.833 947.314 150.211 942.894 146.346 936.364L57.4111 786.139Z",
    fill: "url(#paint67_linear_52_1131)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.411 928.786L43.2203 775.571C40.2859 769.893 40.0965 763.189 42.7056 757.355L113.12 599.913C115.729 594.079 120.853 589.75 127.04 588.153L294.036 545.041C300.224 543.444 306.803 544.751 311.91 548.593L449.736 652.276C454.843 656.118 457.922 662.076 458.103 668.464L462.974 840.866C463.154 847.255 460.416 853.377 455.534 857.501L323.781 968.8C318.899 972.924 312.405 974.601 306.137 973.355L136.974 939.741C130.705 938.495 125.345 934.463 122.411 928.786ZM39.6668 777.407C36.1735 770.648 35.948 762.667 39.0542 755.722L109.468 598.28C112.574 591.335 118.674 586.182 126.041 584.28L293.036 541.168C300.403 539.267 308.234 540.823 314.314 545.397L452.14 649.079C458.22 653.653 461.887 660.746 462.101 668.351L466.972 840.753C467.187 848.358 463.927 855.647 458.115 860.557L326.363 971.856C320.551 976.766 312.819 978.762 305.357 977.279L136.194 943.664C128.732 942.182 122.351 937.381 118.858 930.623L39.6668 777.407Z",
    fill: "url(#paint68_linear_52_1131)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_1131",
    x1: 2102.86,
    y1: 162.499,
    x2: 2263.04,
    y2: 868.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_1131",
    x1: 2099.71,
    y1: 188.304,
    x2: 2221.52,
    y2: 897.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_52_1131",
    x1: 2095.15,
    y1: 214.839,
    x2: 2178.69,
    y2: 925.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_52_1131",
    x1: 2089.18,
    y1: 242.027,
    x2: 2134.63,
    y2: 951.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_52_1131",
    x1: 2081.78,
    y1: 269.783,
    x2: 2089.44,
    y2: 976.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_52_1131",
    x1: 2072.91,
    y1: 298.025,
    x2: 2043.2,
    y2: 1000.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_52_1131",
    x1: 2062.59,
    y1: 326.671,
    x2: 1996.01,
    y2: 1022.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_52_1131",
    x1: 2050.79,
    y1: 355.64,
    x2: 1947.96,
    y2: 1042.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_52_1131",
    x1: 2037.51,
    y1: 384.849,
    x2: 1899.14,
    y2: 1061.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_52_1131",
    x1: 2022.77,
    y1: 414.218,
    x2: 1849.68,
    y2: 1078.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_52_1131",
    x1: 2006.55,
    y1: 443.665,
    x2: 1799.65,
    y2: 1093.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_52_1131",
    x1: 1988.89,
    y1: 473.111,
    x2: 1749.17,
    y2: 1107.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_52_1131",
    x1: 1969.78,
    y1: 502.481,
    x2: 1698.32,
    y2: 1119.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_52_1131",
    x1: 1949.25,
    y1: 531.696,
    x2: 1647.22,
    y2: 1129.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_52_1131",
    x1: 1927.33,
    y1: 560.683,
    x2: 1595.97,
    y2: 1137.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_52_1131",
    x1: 1904.03,
    y1: 589.368,
    x2: 1544.65,
    y2: 1144.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_52_1131",
    x1: 1879.39,
    y1: 617.683,
    x2: 1493.38,
    y2: 1149.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_52_1131",
    x1: 1853.45,
    y1: 645.56,
    x2: 1442.26,
    y2: 1152.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_52_1131",
    x1: 1826.24,
    y1: 672.933,
    x2: 1391.37,
    y2: 1154.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_52_1131",
    x1: 1797.81,
    y1: 699.737,
    x2: 1340.82,
    y2: 1154.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_52_1131",
    x1: 1768.19,
    y1: 725.919,
    x2: 1290.68,
    y2: 1152.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_52_1131",
    x1: 1737.44,
    y1: 751.417,
    x2: 1241.07,
    y2: 1149.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_52_1131",
    x1: 1705.59,
    y1: 776.18,
    x2: 1192.05,
    y2: 1144.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_52_1131",
    x1: 1672.72,
    y1: 800.158,
    x2: 1143.72,
    y2: 1138.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_52_1131",
    x1: 1638.87,
    y1: 823.301,
    x2: 1096.16,
    y2: 1131.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_52_1131",
    x1: 1604.09,
    y1: 845.571,
    x2: 1049.44,
    y2: 1121.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_52_1131",
    x1: 1568.44,
    y1: 866.926,
    x2: 1003.64,
    y2: 1111.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_52_1131",
    x1: 1531.99,
    y1: 887.329,
    x2: 958.826,
    y2: 1099.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_52_1131",
    x1: 1494.79,
    y1: 906.75,
    x2: 915.058,
    y2: 1087.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_52_1131",
    x1: 1456.91,
    y1: 925.157,
    x2: 872.407,
    y2: 1073.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_52_1131",
    x1: 1418.4,
    y1: 942.53,
    x2: 830.924,
    y2: 1058.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_52_1131",
    x1: 1379.34,
    y1: 958.844,
    x2: 790.66,
    y2: 1042.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_52_1131",
    x1: 1339.78,
    y1: 974.084,
    x2: 751.658,
    y2: 1025.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_52_1131",
    x1: 1299.8,
    y1: 988.235,
    x2: 713.973,
    y2: 1007.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_52_1131",
    x1: 1259.45,
    y1: 1001.29,
    x2: 677.634,
    y2: 989.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_52_1131",
    x1: 1218.79,
    y1: 1013.24,
    x2: 642.665,
    y2: 970.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_52_1131",
    x1: 1177.9,
    y1: 1024.09,
    x2: 609.1,
    y2: 950.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_52_1131",
    x1: 1136.84,
    y1: 1033.82,
    x2: 576.963,
    y2: 930.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_52_1131",
    x1: 1095.67,
    y1: 1042.47,
    x2: 546.266,
    y2: 910.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_52_1131",
    x1: 1054.44,
    y1: 1050.01,
    x2: 517.018,
    y2: 889.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_52_1131",
    x1: 1013.23,
    y1: 1056.48,
    x2: 489.229,
    y2: 868.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_52_1131",
    x1: 972.083,
    y1: 1061.89,
    x2: 462.889,
    y2: 847.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_52_1131",
    x1: 931.064,
    y1: 1066.25,
    x2: 438.004,
    y2: 826.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_52_1131",
    x1: 890.221,
    y1: 1069.58,
    x2: 414.555,
    y2: 805.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_52_1131",
    x1: 849.615,
    y1: 1071.91,
    x2: 392.531,
    y2: 785.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_52_1131",
    x1: 809.302,
    y1: 1073.27,
    x2: 371.916,
    y2: 764.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_52_1131",
    x1: 769.32,
    y1: 1073.68,
    x2: 352.675,
    y2: 744.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_52_1131",
    x1: 729.719,
    y1: 1073.18,
    x2: 334.779,
    y2: 724.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_52_1131",
    x1: 690.549,
    y1: 1071.8,
    x2: 318.196,
    y2: 705.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_52_1131",
    x1: 651.848,
    y1: 1069.57,
    x2: 302.886,
    y2: 686.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_52_1131",
    x1: 613.661,
    y1: 1066.55,
    x2: 288.808,
    y2: 668.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_52_1131",
    x1: 576.017,
    y1: 1062.76,
    x2: 275.905,
    y2: 651.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_52_1131",
    x1: 538.955,
    y1: 1058.24,
    x2: 264.133,
    y2: 634.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_52_1131",
    x1: 502.506,
    y1: 1053.05,
    x2: 253.432,
    y2: 618.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_52_1131",
    x1: 466.692,
    y1: 1047.23,
    x2: 243.739,
    y2: 603.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_52_1131",
    x1: 431.547,
    y1: 1040.81,
    x2: 234.997,
    y2: 589.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_52_1131",
    x1: 397.093,
    y1: 1033.85,
    x2: 227.142,
    y2: 576.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_52_1131",
    x1: 363.347,
    y1: 1026.4,
    x2: 220.101,
    y2: 564.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_52_1131",
    x1: 330.32,
    y1: 1018.5,
    x2: 213.797,
    y2: 553.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_52_1131",
    x1: 298.033,
    y1: 1010.2,
    x2: 208.165,
    y2: 544.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_52_1131",
    x1: 266.492,
    y1: 1001.55,
    x2: 203.124,
    y2: 535.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_52_1131",
    x1: 235.709,
    y1: 992.59,
    x2: 198.599,
    y2: 528.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_52_1131",
    x1: 205.684,
    y1: 983.378,
    x2: 194.508,
    y2: 522.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_52_1131",
    x1: 176.42,
    y1: 973.957,
    x2: 190.771,
    y2: 517.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_52_1131",
    x1: 147.915,
    y1: 964.375,
    x2: 187.304,
    y2: 513.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_52_1131",
    x1: 120.168,
    y1: 954.677,
    x2: 184.029,
    y2: 511.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_52_1131",
    x1: 93.1634,
    y1: 944.912,
    x2: 180.854,
    y2: 510.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_52_1131",
    x1: 66.9054,
    y1: 935.116,
    x2: 177.709,
    y2: 510.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_52_1131",
    x1: 41.3694,
    y1: 925.341,
    x2: 174.496,
    y2: 512.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctagon1);
export default __webpack_public_path__ + "static/media/Octagon1.9d062bf870f04e59bf722d19de74ad51.svg";
export { ForwardRef as ReactComponent };